export default __webpack_public_path__ + "static/media/Conviction2_2.9f0630b4.png";